import React, { useState } from 'react';
import './CategoryPicker.css';

const MOBILE_VISIBLE = 8;

export default function CategoryPicker({ items, selected, onToggle, onClear, icons, label }) {
  const [expanded, setExpanded] = useState(false);
  const collapsible = items.length > MOBILE_VISIBLE;

  return (
    <div className={`category-picker ${collapsible && !expanded ? 'collapsed' : ''}`}>
      {label && (
        <div className="picker-label-row">
          <label className="picker-label">{label}</label>
          {onClear && selected.length > 0 && (
            <button type="button" className="picker-clear" onClick={onClear}>Clear</button>
          )}
        </div>
      )}
      {!label && onClear && selected.length > 0 && (
        <button type="button" className="picker-clear picker-clear-unlabeled" onClick={onClear}>Clear filters</button>
      )}
      <div className="picker-grid">
        {items.map((item, i) => (
          <button
            key={item}
            type="button"
            className={`picker-item ${selected.includes(item) ? 'selected' : ''} ${collapsible && i >= MOBILE_VISIBLE ? 'picker-overflow' : ''}`}
            onClick={() => onToggle(item)}
          >
            {icons?.[item] && <span className="picker-icon">{icons[item]}</span>}
            <span>{item}</span>
          </button>
        ))}
        {collapsible && (
          <button
            type="button"
            className="picker-item picker-more"
            onClick={() => setExpanded(!expanded)}
          >
            <span>{expanded ? 'Less ▲' : `+${items.length - MOBILE_VISIBLE} more ▼`}</span>
          </button>
        )}
      </div>
    </div>
  );
}
